const scheduledServicesOutput = {
  title: `Serviços a Realizar`,
  title1: `Serviços Vencidos`
};

export default scheduledServicesOutput;
